import { atom, selector, atomFamily } from 'recoil'
import { ABTEST_LIST_STATUS_ALL, ABTEST_LIST_TYPE_ALL } from 'Constants'

export const resultsState = atom({
  key: 'AbTestListResults',
  default: {
    items: [],
    totalItems: 0,
    searchParams: {},
    sendingfailedIds: []
  }
})

export const messageDetailsState = atomFamily({
  key: 'AbTestListMessageDetails',
  default: {
    loading: true,
    loaded: false,
    subject: undefined
  }
})

export const resultsStateSearchParams = selector({
  key: 'AbTestListResultsStateSearchParams',
  get: ({ get }) => get(resultsState).searchParams,
  set: ({ set }, searchParams) =>
    set(resultsState, prev => ({
      ...prev,
      searchParams
    }))
})

export const resultsStateEmptyState = selector({
  key: 'AbTestListResultsStateEmptyState',
  get: ({ get }) => {
    const { items, searchParams } = get(resultsState)
    const hasSearchParams = evalSearchHasParams(searchParams)
    return !hasSearchParams && !items.length
  }
})

export const resultsStateHasSearchParams = selector({
  key: 'AbTestListResultsStateHasSearchParams',
  get: ({ get }) => {
    const { searchParams } = get(resultsState)
    return evalSearchHasParams(searchParams)
  }
})

const evalSearchHasParams = searchParams => {
  const ret = false
  const keys = Object.keys(searchParams)

  for (let i = 0; i < keys.length; i++) {
    if (keys[i] === 'searchText' && searchParams[keys[i]] !== '' && searchParams[keys[i]] !== null) {
      return true
    }

    if (keys[i] === 'filterType' && searchParams[keys[i]] !== '' && searchParams[keys[i]] !== null) {
      return true
    }

    if (keys[i] === 'filterStatus' && searchParams[keys[i]] !== '' && searchParams[keys[i]] !== null) {
      return true
    }

    if (keys[i] === 'filterTags' && searchParams[keys[i]] && searchParams[keys[i]].length) {
      return true
    }

    if (keys[i] === 'filterMessages' && searchParams[keys[i]] && searchParams[keys[i]].length) {
      return true
    }
  }
  return ret
}

export const modalDeleteState = atom({
  key: 'AbTestListModalDeleteState',
  default: {
    show: false,
    state: 0,
    name: '',
    idABTest: 0
  }
})

export const modalRecoverState = atom({
  key: 'AbTestListModalRecoverState',
  default: {
    show: false,
    state: 0,
    name: '',
    idABTest: 0
  }
})

export const rowState = atomFamily({
  key: 'AbTestListRowState',
  default: {
    titleLoaded: false,
    detailsCount: -1,
    numberOfMessageLoaded: 0,
    numberOfMessage: 0,
    messageState: []
  }
})
